// frontend/src/components/grid/daysOfCoverColumn.js
//
// The Days of cover column of the Projected Stockout report and the Home
// Stockout risk grid. Both read the same server number
// (reporting.ingredients.days_of_cover_expr over Available alone), so they
// share one label, one tooltip and one text.
//
// The server sends null when there is stock but no sales to project, and 0
// when the stock does not last a full day (an empty shelf included); the
// cell shows "—" for the first.

export function daysOfCoverColDef({ t, formatNumber }) {
  return {
    field: 'days_of_cover',
    headerName: t('reports.stockout.columns.daysOfCover'),
    type: 'numberColumn',
    headerTooltip: t('common.tooltips.daysOfCover'),
    valueFormatter: (p) => p.value == null ? '—' : formatNumber(p.value, 0),
  };
}
